import { isUndefined } from 'lodash'
import { FeatureContentElementKey, FeatureContentVersions, FeatureContentVersionType } from '../feature-versioning'

/**
 * Determines if an element (e.g. dashboard sidebar element) has new content by comparing the current content versions with the one saved in the user settings.
 *
 * @param elementsWithNewFeatures
 * @param element
 */
export const getHasElementNewContent = (userFeatureContentVersion: FeatureContentVersionType, elementKey: FeatureContentElementKey): boolean => {
  const elementUserFeatureContentVersion = userFeatureContentVersion[elementKey]
  const elementFeatureContentVersion = FeatureContentVersions[elementKey]

  if (isUndefined(elementUserFeatureContentVersion)) return true
  if (elementUserFeatureContentVersion > elementFeatureContentVersion) return false
  return elementUserFeatureContentVersion !== elementFeatureContentVersion
}

/**
 * Returns true if one of the elements you can access via the parent element (e.g. property icon in bottom bar) has new content
 *
 * @param userFeatureContentVersion
 * @param elementKeys
 * @returns
 */
export const getHaveElementsNewContent = (userFeatureContentVersion: FeatureContentVersionType, elementKeys: FeatureContentElementKey[]): boolean => {
  return elementKeys.some(key => getHasElementNewContent(userFeatureContentVersion, key))
}
